import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.92,25.97c-1.04,12.44-11.44,22-23.92,22h-1.11l0,0L12.47,37.74l0,0l-0.8-0.77l13-12.83l0.17-0.16l0.48-0.48
l0,0l0.3-0.3l0,0l0.33-0.33l0.41-0.4l0.82-0.81l0,0l0.1-0.11l0.25-0.25l2-1.95l2.8-2.76l0.18-0.18l0,0l0,0L33,15.97l0.9-0.88l0,0
l3.1-3.12l0.43,0.55L47.92,25.97z"
  />
);

const TotoAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_6}
    renderShadow={renderShadow}
  >
    <>
      <path
        style={{ fill: '#333333' }}
        d="M20.28,24.31c0,0-3.67-8.55-4.28-9.34c-0.86-1.12-0.6,1.65-0.73,2.64c-0.03,1.16,0.08,2.32,0.35,3.45
	c0.07,0.41,0.24,0.79,0.49,1.12L17,23.3c0.31,0.4,0.77,0.66,1.27,0.74L20.28,24.31z"
      />
      <path
        style={{ fill: '#AF7B6B' }}
        d="M13.4,23.97h21.2c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2H13.4c-1.1,0-2-0.9-2-2v-10
	C11.4,24.87,12.3,23.97,13.4,23.97z"
      />
      <path
        style={{ fill: '#AF7B6B' }}
        d="M19.66,10.37L19.66,10.37c0.52-0.18,1.09,0.09,1.28,0.61l4.35,12.25l0,0L23.4,23.9l0,0l-4.35-12.25
	C18.87,11.13,19.14,10.56,19.66,10.37z"
      />
      <ellipse
        transform="matrix(0.1213 -0.9926 0.9926 0.1213 7.5294 46.4475)"
        style={{ fill: '#333333' }}
        cx="30"
        cy="18.97"
        rx="5.16"
        ry="6.45"
      />
      <path
        style={{ fill: '#333333' }}
        d="M28.42,15.9c0,0-0.67-4-2.65-5.74s-2,8.92-2,8.92L28.42,15.9z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M32.11,16.2c0,0,2-3.53,4.47-4.51s-1.18,9.12-1.18,9.12L32.11,16.2z"
      />
      <ellipse
        transform="matrix(0.9754 -0.2204 0.2204 0.9754 -4.9447 6.5262)"
        style={{ fill: '#333333' }}
        cx="26.78"
        cy="25.43"
        rx="1.93"
        ry="2.58"
      />
      <ellipse
        transform="matrix(0.2589 -0.9659 0.9659 0.2589 1.2314 52.2563)"
        style={{ fill: '#333333' }}
        cx="34.67"
        cy="25.33"
        rx="2.59"
        ry="1.94"
      />
      <ellipse
        style={{ fill: '#333333' }}
        cx="31.29"
        cy="22.19"
        rx="3.87"
        ry="3.22"
      />
      <polygon
        style={{ fill: '#333333' }}
        points="27.42,15.1 28.71,12.52 30,15.1 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="28.71,15.1 30,11.23 31.29,15.1 30,15.1 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="30,15.1 31.29,11.23 32.58,16.39 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="30.64,15.1 32.58,12.52 32.58,16.39 31.29,15.53 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="33.87,12.52 31.29,15.1 33.87,16.39 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="23.82,17.29 22.26,17.68 23.55,18.97 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="23.55,18.97 22.26,19.6 23.78,19.99 24.84,20.26 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="24.84,18.97 22.26,21.55 24.84,21.55 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="24.84,20.26 23.55,22.84 27.42,21.55 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="26.13,21.55 22.26,24.13 26.91,24.13 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="35.16,17.68 37.74,18.97 35.16,20.26 35.16,19.08 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="35.16,18.97 37.74,20.26 35.16,21.55 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="35.16,20.26 37.74,22.84 33.79,21.55 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="35.16,21.55 37.74,24.13 32.58,24.13 "
      />
      <circle style={{ fill: '#FFFFFF' }} cx="28.07" cy="18.33" r="0.64" />
      <circle style={{ fill: '#FFFFFF' }} cx="33.22" cy="18.33" r="0.64" />
      <ellipse
        style={{ fill: '#E28F86' }}
        cx="31.29"
        cy="20.9"
        rx="1.29"
        ry="0.64"
      />
      <polygon
        style={{ fill: '#333333' }}
        points="18.24,24.04 15,22.97 16.55,22.45 18,21.97 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="18,23.97 14,20.97 17,20.97 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="16.97,23.3 14,18.97 17,18.97 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="16.69,23.11 14.31,16.83 16.3,17.04 "
      />
    </>
  </AvatarArtwork>
);

export default TotoAvatarArtwork;
